import { v4 as uuid } from 'uuid'
import { cloneDeep } from 'lodash-es'
import { CombatController } from '../components/combat/CombatController'
import { SaveController } from '../components/save/SaveController'
import { ItemType } from '@/class'

interface IPlaceholderData {
  id: string
  name: string
  Mechname?: string
  type: string // 'pilot' | 'npc' | 'other'
  side: string // 'ally' | 'enemy'
  notes?: string
  combat_data?: any
}

class Placeholder {
  public ID: string
  public Name: string
  public Side: string = 'ally' // Default side
  public Mechname?: string
  public Notes?: string
  public PlaceholderType: string
  public SaveController: SaveController
  public CombatController: CombatController
  public Icon: string = 'mdi-receipt-text'
  public readonly ItemType: ItemType = ItemType.Placeholder
  public readonly StorageType: string = 'none'
  public readonly Placeholder = true
  public Deployables: any = []

  public ActiveMech?: Placeholder

  constructor(data: IPlaceholderData) {
    this.ID = data.id
    this.Name = data.name
    this.Side = data.side
    this.Mechname = data.Mechname
    this.Notes = data.notes
    this.PlaceholderType = data.type
    this.SaveController = new SaveController(this)
    this.CombatController = new CombatController(this)

    if (this.PlaceholderType === 'pilot') {
      this.ActiveMech = new Placeholder({
        id: this.ID + '_activeMech',
        name: this.Mechname || 'Mech',
        type: 'mech',
        side: this.Side,
      })
    }

    switch (this.PlaceholderType.toLowerCase()) {
      case 'pilot':
        this.Icon = 'cc:pilot'
        break
      case 'npc':
        this.Icon = 'cc:frame'
        break
      default:
        this.Icon = 'mdi-receipt-text'
        break
    }
  }

  public SetStats(): void {}

  public get StatController(): any {
    return this.CombatController.StatController
  }

  public Serialize(): IPlaceholderData {
    const combat_data = {} as any
    CombatController.Serialize(this.CombatController, combat_data)
    return {
      id: this.ID,
      name: this.Name,
      Mechname: this.Mechname,
      type: this.PlaceholderType,
      side: this.Side,
      notes: this.Notes,
      combat_data,
    }
  }

  public static Deserialize(data: IPlaceholderData): Placeholder {
    if (!data || !data.id) {
      throw new Error('Invalid Placeholder data')
    }
    const p = new Placeholder({
      id: data.id,
      name: data.name,
      Mechname: data.Mechname,
      type: data.type,
      side: data.side,
      notes: data.notes,
    })
    if (data.combat_data) CombatController.Deserialize(p.CombatController, data.combat_data)
    return p
  }

  public save(): void {}

  public Clone(): Placeholder {
    const data = cloneDeep(this.Serialize())
    data.id = uuid()
    return Placeholder.Deserialize(data)
  }
}
export { Placeholder }
export type { IPlaceholderData }
